/*
 *  Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 *  All information herein, source code below as well as the Morpheus system itself and all related
 *  software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 *  Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 *  is prohibited.
 */

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/router'
import store from '@/store/index'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import * as filters from '@morpheus/utils/admin-vue/filters/index'
import { AxiosPlugin } from '@/services/axios'
import DatetimePicker from 'vuetify-datetime-picker'

// extend VeeValidate dictionary
const dictionary = {
  en: {
    messages: {
      required_if: (field: string, ref: Array<string>) => `The ${field} field is required when the field has value ${ref[0]}.`
    }
  }
}
VeeValidate.Validator.localize(dictionary)

Vue.use(Vuetify, {
  theme: {
    primary: process.env.VUE_APP_API_COLOR_PRIMARY || '#1976d2',
    accent: process.env.VUE_APP_API_COLOR_PRIMARY || '#1976d2'
  }
})
Vue.use(VeeValidate)
Vue.use(DatetimePicker)

Vue.config.productionTip = false

Object.entries(filters).forEach(([key, value]) => {
  Vue.filter(key, value)
})

Vue.use(AxiosPlugin, { store })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
